import Api from "../services/Api";



export const registerUser = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/auth/register', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};